var React = require('react');

function IndigoCheckmark (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"22","height":"22","rx":"11","fill":"#6366F1","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.6223 7.19605C17.8281 7.39295 17.8281 7.72176 17.6223 7.91866L9.51169 15.6775C9.06214 16.1075 8.33327 16.1075 7.88372 15.6775L4.37769 12.3235C4.17186 12.1266 4.17186 11.7978 4.37769 11.6009L5.28234 10.7355C5.47566 10.5506 5.78029 10.5506 5.9736 10.7355L8.6977 13.3414L16.0264 6.33064C16.2197 6.14571 16.5243 6.14571 16.7177 6.33064L17.6223 7.19605Z","fill":"white","key":1})]);
}

IndigoCheckmark.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = IndigoCheckmark;

IndigoCheckmark.default = IndigoCheckmark;
